<script setup>
import WebsiteVariantForm from '@frontJs/components/forms/projectManagement/customers/WebsiteVariantForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, websiteVariant, defaultBaseUrl, countries, languages } =
    defineProps({
        tenant: {
            type: Object,
            required: true,
        },
        websiteVariant: {
            type: [Object, null],
            required: false,
            default: null,
        },
        defaultBaseUrl: {
            type: String,
            required: true,
        },
        countries: {
            type: Array,
            required: true,
        },
        languages: {
            type: Array,
            required: true,
        },
    });

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="websiteVariant">
            Mettre à jour le site #{{ websiteVariant.id }} - Clients - Gestion
            de projet - Datakepler
        </title>

        <title v-else>
            Créer un site - Clients - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="websiteVariant" :tenant-name="tenant.name">
        Gestion de projet - Clients - Mettre à jour le site #{{
            websiteVariant.id
        }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - Clients - Créer un site
    </PageTitle>

    <WebsiteVariantForm
        :tenant="tenant"
        :website-variant="websiteVariant"
        :default-base-url="defaultBaseUrl"
        :countries="countries"
        :languages="languages"
    />
</template>
